let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hGlFt")).then(() => parcelRequire('1H9in'));